<script lang="ts" setup>
import LoadingSpin from '~common/loading-spin.vue'
import { useInstruction } from '~composables/instruction/use-instruction'
import { useLogin } from '~/composables/account/use-login'

const route = useRoute()
const { isLogged } = useLogin()
const {
  loading,
  postDetail,
  instructMenu,
  postContentRef,
  breadcrumbTitle,
  fetchInstructionData,
  transactionNavigation,
  navigateToTransaction
} = useInstruction()

await fetchInstructionData(typeof route.params.slug === 'string' ? route.params.slug : undefined)
</script>

<template>
  <section class="about">
    <div class="container">
      <div class="about__breadcrumb">
        <span class="icon-news-home"></span>
        <NuxtLink to="/">Trang chủ</NuxtLink>
        <span class="icon-chevron-right"></span>
        <NuxtLink class="current-slug">{{ breadcrumbTitle }}</NuxtLink>
      </div>

      <div class="about__block d-flex align-items-start">
        <div class="about__sidebar">
          <div class="about__sidebar--title">Trung tâm thông tin</div>

          <div class="about__sidebar--menu">
            <template v-for="item in instructMenu" :key="item.slug">
              <div :class="['about__sidebar--item ', { active: item.slug === route.params.slug }]">
                <div class="d-flex align-items-center">
                  <img :src="item.icon" class="about__sidebar--item--icon" :alt="item.title" />
                  <NuxtLink :to="item.slug" class="about__sidebar--item--link">
                    {{ item.title }}
                  </NuxtLink>
                </div>

                <div v-if="item.subItems" class="about__sidebar--submenu">
                  <NuxtLink
                    v-for="menu in item.subItems"
                    :key="menu.slug"
                    :to="menu.slug"
                    :class="['about__sidebar--submenu-item', { active: menu.slug === route.params.slug }]"
                  >
                    {{ menu.title }}
                  </NuxtLink>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="about__content">
          <LoadingSpin v-if="loading" />
          <template v-if="!loading">
            <div ref="postContentRef" class="about__content--txt" v-html="postDetail"></div>
          </template>

          <ClientOnly>
            <div v-if="isLogged && transactionNavigation">
              <div class="instruction-footer-content">
                {{ transactionNavigation.text }}
                <button class="button main main--primary text-nowrap" @click="navigateToTransaction">
                  {{ transactionNavigation.button }}
                </button>
              </div>
            </div>
          </ClientOnly>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/about/index.scss';
</style>
